<template>
  <confirmation-dialog
    v-bind="$attrs"
    :disabled="!userConfirm"
    :loading="loading"
    ok-button-text="Clear Error"
    title="Manually clear sync error?"
    @confirm="clear"
    @update:model-value="$emit('update:model-value', $event)"
  >
    When you clear the sync error manually, the future order updates will no longer sync with your accounting system.
    <div class="d-flex mt-4">
      <qtm-checkbox v-model="userConfirm" default-color="mid-dark-grey" />
      <span class="ml-3">
        I acknowledge that the future order updates will
        <span class="font-weight-bold pa-0">no longer sync</span>
        with your accounting system.
      </span>
    </div>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import ConfirmationDialog from '@/components/confirmation-dialog.vue'

export interface Props {
  endpoint?: 'expenses' | 'invoices' | 'purchaseOrders' | 'receipts'
  objectId?: number
}

const props = withDefaults(defineProps<Props>(), {
  endpoint: 'purchaseOrders',
  objectId: undefined
})

const emit = defineEmits(['cleared', 'update:model-value'])
const loading = ref(false)
const userConfirm = ref(false)
const { $api, $error, $tracker } = useNuxtApp()
const clear = async () => {
  loading.value = true
  try {
    await $api.v1[props.endpoint].clearAccountingError(props.objectId as number)

    $tracker.track('Clear Error Manually', {
      entity: props.endpoint,
      entity_id: props.objectId
    })
    emit('cleared')
    emit('update:model-value', false)
  }
  catch (error) {
    $error.report(error)
  }
  loading.value = false
}
</script>
